<!-- 登录日志 -->
<template>
  <div class="operlog" v-loading="loading">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="userName" placeholder="请输入用户名称" @change="onSearch" clearable></el-input>
      <el-date-picker class="" v-model="datetime" type="daterange" range-separator="至" start-placeholder="选择开始日期" end-placeholder="选择结束日期" value-format="yyyy-MM-dd" @change="onSearch" clearable></el-date-picker>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="operateName" label="登录名称"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="userName" label="登录用户"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="operateIp" label="登录IP地址"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="ipRegion" label="IP归属地"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="operateTime" label="登录时间"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" prop="operateResult" label="登录结果">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.operateResult == 1">成功</el-tag>
            <el-tag type="danger" v-if="scope.row.operateResult == 2">失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="operateContent" label="登录数据">
          <template slot-scope="scope">
            <el-button type="" @click="handleDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog title="查看详情" :visible.sync="dialogVisible" width="30%">
      <h3>登录数据</h3>
      <br />
      <pre>{{ backendCode }}</pre>
      <br />
      <h3>失败原因</h3>
      <br />
      <pre>{{ failContent }}</pre>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      userName: "",
      datetime: [],
      startTime: "",
      endTime: "",
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）

      backendCode: "",
      failContent: "",
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.datetime = this.datetime || []
      this.startTime = this.datetime[0] || null
      this.endTime = this.datetime[1] || null

      this.loading = true
      this.$axios
        .get(this.$api.sysOperateLogpageList, {
          params: {
            bizSys: this.$store.state.userInfo.bizSys, // 业务系统 (1管理后台；2供应商；3采购商)
            bizType: 2, // 业务类型 (1操作；2登录)
            bizId: this.$store.state.userInfo.bizId,
            userName: this.userName,
            startTime: this.startTime,
            endTime: this.endTime,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list || []
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    handleDetail(row) {
      this.dialogVisible = true
      this.backendCode = ""
      this.failContent = ""
      if (row.operateContent) this.backendCode = JSON.parse(row.operateContent)
      if (row.failContent) this.failContent = row.failContent
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
  },
}
</script>

<style scoped lang="scss">
pre {
  min-height: 150px;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  white-space: pre-wrap;
}
</style>
